import { profanity } from "@2toad/profanity";

export const PROFANITY_ERROR_MESSAGE =
  "Your post contains offensive language. Please remove it before sharing.";

export interface LearningWallTextFields {
  title: string;
  description: string;
  tags: string;
}

export interface LearningWallValidationResult {
  title?: string;
  description?: string;
  tags?: string;
  hasProfanity: boolean;
}

const hasProfanity = (value: string) => {
  const normalizedValue = value.trim();
  return normalizedValue.length > 0 && profanity.exists(normalizedValue);
};

export const validateLearningWallTextFields = (
  fields: LearningWallTextFields
): LearningWallValidationResult => {
  const title = hasProfanity(fields.title)
    ? "Please remove offensive language from the title."
    : undefined;
  const description = hasProfanity(fields.description)
    ? "Please remove offensive language from the description."
    : undefined;
  const tags = hasProfanity(fields.tags)
    ? "Please remove offensive language from the tags."
    : undefined;

  return {
    title,
    description,
    tags,
    hasProfanity: Boolean(title || description || tags)
  };
};
